// NPM Import
import React from "react";
import { Label } from "../../../../revvComponents";

// Component Imports
import { ReactSelect } from "../../../../commonComponents";
import { GlobalUtils } from "../../../../utils";

// Destructuring
const { addValueAndLabelPropsForSelectOptions } = GlobalUtils;

export default function UserRoleSelectInSettingPage(props) {
  const { title, optionData, roles, onSelectChange } = props;
  return (
    <div className="inviteteammatespopup-form-field">
      <Label htmlFor="userRole">{title}</Label>
      <ReactSelect
        data-testid="userrole-list"
        valueKey="type"
        onChange={value => onSelectChange("userRole", value)}
        options={addValueAndLabelPropsForSelectOptions(roles, "name")}
        value={optionData}
        isDisabled={props.disabledData()}
        data-test="productconfigurationselect-select"
      />
    </div>
  );
}
